import type { McsChecklistItem } from '../../types/mcsPrep';
export function checklistProgress(items: Pick<McsChecklistItem, 'status'>[]) {
  return items.reduce((counts, item) => {
    const key = { done: 'done', todo: 'todo', needs_attention: 'needsAttention', not_applicable: 'notApplicable' } as const;
    counts[key[item.status]] += 1;
    return counts;
  }, { done: 0, todo: 0, needsAttention: 0, notApplicable: 0 });
}
export function itemLabelKey(key: string): string {
  if (/^evaluation_training_(acc|pcc|mcc)$/.test(key)) return 'mcs.items.evaluation_training';
  if (/^application_(acc|pcc|mcc)$/.test(key)) return 'mcs.items.application';
  return ['eligible_credential', 'education_hours', 'experience_five_mentees', 'renewal_plan'].includes(key) ? `mcs.items.${key}` : 'mcs.items.other';
}
